import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const Cycle20: FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path fillRule="evenodd" clipRule="evenodd" d="M14.9092 3.7938C14.7033 3.38234 14.2026 3.21595 13.791 3.42173L12.124 4.25473L11.4775 4.57798L12.4517 7.5005H8.84556L8.47298 6.75473C8.19066 6.19009 7.61306 5.83384 6.98177 5.83384H5.8304C5.37017 5.83384 4.9974 6.20661 4.9974 6.66684C4.9974 7.12708 5.37017 7.49985 5.8304 7.49985H6.98177L7.34674 8.2292L6.3631 9.459C5.94624 9.27149 5.48385 9.16717 4.99707 9.16717C3.15612 9.16717 1.66406 10.6592 1.66406 12.5002C1.66406 14.3411 3.15612 15.8332 4.99707 15.8332C6.55038 15.8332 7.85531 14.771 8.22516 13.3332H9.99707V11.6672H8.22516C8.11497 11.2388 7.92176 10.8438 7.66371 10.5002L8.73047 9.16652H13.0071L13.1855 9.7019C12.2698 10.2959 11.6641 11.3272 11.6641 12.5002C11.6641 14.3411 13.1561 15.8332 14.9971 15.8332C16.838 15.8332 18.3301 14.3411 18.3301 12.5002C18.3301 10.6592 16.838 9.16717 14.9971 9.16717C14.92 9.16717 14.8435 9.16979 14.7677 9.17494L13.5166 5.42173L14.5361 4.91196C14.9478 4.70614 15.115 4.20545 14.9092 3.7938ZM4.99707 10.8332C5.91754 10.8332 6.66406 11.5797 6.66406 12.5002C6.66406 13.4207 5.91754 14.1672 4.99707 14.1672C4.0766 14.1672 3.33008 13.4207 3.33008 12.5002C3.33008 11.5797 4.0766 10.8332 4.99707 10.8332ZM14.9971 10.8332C15.9175 10.8332 16.6641 11.5797 16.6641 12.5002C16.6641 13.4207 15.9175 14.1672 14.9971 14.1672C14.0766 14.1672 13.3301 13.4207 13.3301 12.5002C13.3301 11.5797 14.0766 10.8332 14.9971 10.8332Z" fill={color} />
      </svg>
    </IconContainer>
  );
};
